import { HomeBatteryOutlineIcon } from './HomeBatteryOutlineIcon';

/**
 * author: Michael Irigoyen
 * id EFDF1C9C-3566-4312-ACBC-AC5B10EA28DE
 * name home-battery-outline
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-battery-outline.svg
 * tags
 * - Home Automation 
 * - Battery 
 */
export const HomePowerOutlineIcon = HomeBatteryOutlineIcon;
export default HomePowerOutlineIcon